import { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import axios from 'axios';
import GaugeChart from 'react-gauge-chart';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const SensorDetail = () => {
  const { id } = useParams();
  const { logout } = useContext(AuthContext);
  const [sensor, setSensor] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSensor = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          console.error("❌ Token no encontrado en localStorage");
          return;
        }

        const response = await axios.get(
          `https://elicromiot.com/api/sensor/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setSensor(response.data);
      } catch (error) {
        console.error("❌ Error al obtener los detalles del sensor:", error);
        setError('Error al cargar detalles del sensor.');
      }
    };

    fetchSensor();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("es-ES", { dateStyle: "short", timeStyle: "medium" });
  };

  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>⬅️ Volver</button>
      <h2 style={styles.title}>Detalles del Sensor</h2>
      
      {error && <p style={styles.error}>{error}</p>}
      {!error && sensor && (
        <div style={styles.card}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Campo</th>
                <th style={styles.th}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}>Nombre</td>
                <td style={styles.td}>{sensor.nombre}</td>
              </tr>
              <tr>
                <td style={styles.td}>Tipo</td>
                <td style={styles.td}>{sensor.tipo}</td>
              </tr>
              <tr>
                <td style={styles.td}>DevEUI</td>
                <td style={styles.td}>{sensor.deveui}</td>
              </tr>
              <tr>
                <td style={styles.td}>Temperatura</td>
                <td style={styles.td}>{sensor.last_reading || 'N/A'} °C</td>
              </tr>
              <tr>
                <td style={styles.td}>Humedad</td>
                <td style={styles.td}>{sensor.last_secondary_reading || 'N/A'} %</td>
              </tr>
              <tr>
                <td style={styles.td}>Última Lectura</td>
                <td style={styles.td}>{formatDate(sensor.fecha)}</td>
              </tr>
              <tr>
                <td style={styles.td}>Ubicación</td>
                <td style={styles.td}>{sensor.lat}, {sensor.lon}</td>
              </tr>
            </tbody>
          </table>

          {sensor.lat && sensor.lon && (
            <div style={styles.map}>
              <MapContainer center={[sensor.lat, sensor.lon]} zoom={15} style={{ height: "300px", width: "100%" }}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[sensor.lat, sensor.lon]}>
                  <Popup>{sensor.nombre}</Popup>
                </Marker>
              </MapContainer>
            </div>
          )}

          <div style={styles.gauges}>
            <div>
              <h4>Temperatura (°C)</h4>
              <GaugeChart 
                id="gauge-chart1"
                nrOfLevels={20}
                percent={sensor.last_reading ? sensor.last_reading / 100 : 0}
                textColor="#2c3e50"
                colors={["#FF5F6D", "#FFC371"]}
                style={{ width: '300px' }}
              />
            </div>
            <div>
              <h4>Humedad (%)</h4>
              <GaugeChart 
                id="gauge-chart2"
                nrOfLevels={20}
                percent={sensor.last_secondary_reading ? sensor.last_secondary_reading / 100 : 0}
                textColor="#2c3e50"
                colors={["#00C6FF", "#0072FF"]}
                style={{ width: '300px' }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '40px',
    backgroundColor: '#f0f4f8',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  backButton: {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '20px',
  },
  title: {
    color: '#34495e',
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '28px',
  },
  card: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    maxWidth: '900px',
    margin: '0 auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '20px',
  },
  th: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    padding: '10px',
    textAlign: 'left',
    borderBottom: '3px solid #0f1d4d',
  },
  td: {
    padding: '10px',
    border: '2px solid #007bff',
  },
  map: {
    marginTop: '20px',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  gauges: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '30px',
  },
  error: {
    textAlign: 'center',
    color: 'red',
    fontSize: '18px',
  },
};

export default SensorDetail;
